module.exports = __webpack_public_path__ + "img/graph.52be2732.svg";